import { LocalizationProvider as LocalizationProviderRoot } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

export const LocalizationProvider = ({ children }: { children: JSX.Element }): JSX.Element => (
  <LocalizationProviderRoot dateAdapter={AdapterDayjs}>{children}</LocalizationProviderRoot>
)
